// import required libraries
import $ from 'jquery';

// import components/functions that run on every page
import renderMainNav from './components/MainNav/actions/renderMainNav';
import renderProducts from './components/Products/actions/renderProducts';

// Import Pages
import accessibility from './actions/accessibility';
import Page404 from './pages/Page404';
import renderCountDownTimer from './actions/renderCountDownTimer';

// call page specific functions
Page404($);

// call global functions
accessibility();
renderMainNav();
renderProducts();
renderCountDownTimer();